import React from 'react'
import PropTypes from 'prop-types'
import { Icon, Button } from '@adc/ui-adc'
import classnames from 'classnames/bind'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const LinkExpandable = ({ elmId, title, expanded = false, toggleExpand }) => {
  const expandIcon = expanded ? 'angle-down' : 'angle-right'
  return (
    <div>
      <Icon name={expandIcon} iconStyle='regular' />
      <Button
        elmId={elmId + '_link'}
        className={cx('left-space', 'link-button-override')}
        onClick={toggleExpand}
        role='navigation'
      >
        {' '}
        {title}{' '}
      </Button>
    </div>
  )
}

LinkExpandable.propTypes = {
  elmId: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  toggleExpand: PropTypes.func.isRequired,
  expanded: PropTypes.bool,
}

export default LinkExpandable
